module.exports = __webpack_public_path__ + "static/media/menu2.245914ea.svg";